// cars/vm-view
import { useListIds } from 'src/hooks/use-list-table';
import { useListSearch } from 'src/hooks/use-list-search';
import { useItemsStore } from 'src/hooks/use-items-store';

import { getCarList, getCarAll, getCarGroupAssigned, getCarDetail, getCarRepairs } from './data-view';
import { formatDate } from 'src/utils/date-locale';
import { distanceColor, expiredColor } from 'src/utils/color-rules';
import TypeChecker from 'src/utils/type-checker';

export const useItemsSearch = () => {
  return useListSearch();
};
export const useItemsIds = () => {
  return useListIds();
};

export const carRepairs = async (carId, options = [], currentUnit = 0) => {
  let params = '';
  if (TypeChecker.isArray(options)) {
    params = options.map(item => item.value).join(',');
  }

  const { result, error } = await getCarRepairs(carId, params);
  if (error) {
    const updatedOptions = options.map(item => ({
      ...item,
      value: ''
    }));
    return updatedOptions;
  }

  const updatedOptions = options.map(option => {
    const match = result.find(item => `${item.label}` === option.value);

    let assetId = 0; 
    let label = option.label;
    let labelId = option.value;
    let expOn = 0;

    let color = 'inherit';
    let value = '';
    if (match) {
      assetId = match.assetId;
      label = match.serviceName;
      labelId = match.label;
      expOn = match.expOn;

      if (match.atKm > 0){
        const obj = distanceColor(match.atKm, match.limitAt, currentUnit);
        color = obj.color;
        value = match.atKm;
      }
      else if (match.expOn > 0){
        const obj = expiredColor(match.expOn, currentUnit);
        color = obj.color;
        value = formatDate(match.expOn, 'dd/MM/yyyy');
      }
    }

    return {
      // ...option,
      label,
      value,
      color,
      assetId,
      labelId,
      expOn,
    };
  });

  return updatedOptions;
};

class CarsApi {
  
  getItemList(searchState, params) {
    return useItemsStore(searchState, getCarList, params);
  }

  getItemAll(searchState) {
    return useItemsStore(searchState, getCarAll);
  }

  getItemAssigned(payload, onSuccess) {
    getCarGroupAssigned(payload).then((result) => {
      return onSuccess(result);
    });
  }

  getItemById(payload, onSuccess) {
    getCarDetail(payload).then((result) => {
      onSuccess(result);
    });
  }
}

export const carsApi = new CarsApi();
